import Vue from 'vue'
import Router from 'vue-router'

// Containers
import DefaultContainer from '@/containers/DefaultContainer'

// Views
import Dashboard from '@/views/Dashboard'

import Colors from '@/views/theme/Colors'
import Typography from '@/views/theme/Typography'

import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'

// Views - Components
import Cards from '@/views/base/Cards'
import Forms from '@/views/base/Forms'
import Switches from '@/views/base/Switches'
import Tables from '@/views/base/Tables'
import Tabs from '@/views/base/Tabs'
import Breadcrumbs from '@/views/base/Breadcrumbs'
import Carousels from '@/views/base/Carousels'
import Collapses from '@/views/base/Collapses'
import Jumbotrons from '@/views/base/Jumbotrons'
import ListGroups from '@/views/base/ListGroups'
import Navs from '@/views/base/Navs'
import Navbars from '@/views/base/Navbars'
import Paginations from '@/views/base/Paginations'
import Popovers from '@/views/base/Popovers'
import ProgressBars from '@/views/base/ProgressBars'
import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
import StandardButtons from '@/views/buttons/StandardButtons'
import ButtonGroups from '@/views/buttons/ButtonGroups'
import Dropdowns from '@/views/buttons/Dropdowns'
import BrandButtons from '@/views/buttons/BrandButtons'

// Views - Icons
import Flags from '@/views/icons/Flags'
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
import CoreUIIcons from '@/views/icons/CoreUIIcons'

// Views - Notifications
import Alerts from '@/views/notifications/Alerts'
import Badges from '@/views/notifications/Badges'
import Modals from '@/views/notifications/Modals'

// Views - Pages
import Page404 from '@/ErrorPage/containers/Page404'
import Page500 from '@/ErrorPage/containers/Page500'

// import demoTemplate from './demoTemplate'
import MyContainer from '@/containers/MyContainer'

import Homepage from '@/Homepage/route'
import Adm from '@/Adm/route'
import Dm from '@/Dm/route'
import Dw from '@/Dw/route'
import My from '@/My/route'
import Osm from '@/Osm/route'
import Crm from '@/Crm/route'
import Auth from '@/Auth/route'
import ErrorPage from '@/ErrorPage/route'
import Quick from '@/Quick/route'

import Cookies from 'js-cookie'
Vue.use(Router)

const role = Cookies.get('role');


export default new Router({
  mode: 'history',
  base: process.env.PREFIX_PATH,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    Auth,
    ErrorPage, 
    {
      path: '/dashboard',
      name: 'Home',
      meta: { label: 'hm' },
      component: MyContainer,
      children: [
        Homepage.dashboard,
        // Homepage.clientDashboard,
        // Homepage.clientPolicyDetail,
        // Adm,
        // Crm,
        // Dm,
        // Dw,
        // My,
        // Osm,
        // Quick
      ]
    },
    {
      path: '/error',
      redirect: '/error/404',
      name: 'Error',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js